import { Component, inject } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { CustomerTestsTypes } from '@enums/customer-tests-types';
import { QuestionnaireAnswers } from '@enums/questionnaire-answers';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { SelectableOption } from '@models/selectable-option';
import { ConsultationStorageService } from '@services/consultation-storage.service';

@Component({
  selector: 'app-vaginal-cream',
  templateUrl: './vaginal-cream.component.html',
  styleUrls: ['./vaginal-cream.component.scss'],
  imports: [UpsellCardComponent],
})
export class VaginalCreamComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.MetronidazoleVaginalGel;
  public readonly options: SelectableOption[] = [
    new SelectableOption('I prefer taking oral medication.', QuestionnaireAnswers.No),
    new SelectableOption('I prefer Metronidazole Vaginal Gel 0.75% (Metrogel).', UpsellSlugs.MetronidazoleVaginalGel),
    new SelectableOption('I prefer Clindamycin Vaginal Cream 2% (Cleocin).', UpsellSlugs.ClindamycinVaginalCream),
  ];

  private consultationStorageService = inject(ConsultationStorageService);

  /**
   * Set the treatment preferences on the local storage based on the vaginal cream option selected on continue button press.
   *
   * @param {string} optionSelected The option selected by the patient.
   */
  public continueButtonPressed(optionSelected: string): void {
    this.consultationStorageService.treatmentPreferences =
      optionSelected === QuestionnaireAnswers.No
        ? this.consultationStorageService.orderedTests.find(
            (test) => test.customer_tests_type === CustomerTestsTypes.Individual,
          ).customer_tests_name
        : optionSelected;
  }
}
